import { render, staticRenderFns } from "./choose-specialty.vue?vue&type=template&id=337a02b6&scoped=true"
import script from "./choose-specialty.vue?vue&type=script&lang=js"
export * from "./choose-specialty.vue?vue&type=script&lang=js"
import style0 from "./choose-specialty.vue?vue&type=style&index=0&id=337a02b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337a02b6",
  null
  
)

export default component.exports